<template>
  <div class="boxHeight">
    <top class="top" :style="{left:-scrollLeft + 'px', 'min-width': ($route.path == '/myAccount/billList' ? '1760px' : '1440px' ) }"></top>
    <div class="index clear boxHeight" @click="goClick">
      <div class="left l" ref="left">
        <leftnav></leftnav>
      </div>
      <div class="right l "  :style="{'min-width': (!isAuto ? '600px' : 'auto' ) }">
        <div class="rightTop" v-if="isHome()">
          <righttop ref="rightTop"></righttop>
        </div>
        <div  class="rightMain" style="height:87%;">
          <!-- <router-view></router-view> -->
          <keep-alive>
            <!-- 页面缓存 -->
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>
      </div>
    </div>

    <!-- <div class="return_top" @click="goTop"></div> -->
  </div>
</template>

<script>
import Vue from "vue";
import leftnav from "./public/leftNav.vue";
import righttop from "./public/rightTop.vue";
import foot from "./public/menberFooterInfo.vue";
import Top from "../backstageManagement/home/public/navTopHeader/index.vue"
import { getAccountInfo } from '@/util/util'
import { getCookie } from "@/ask/cookiejs";
export default {
  components: { leftnav, righttop, foot, Top },
  data() {
    return {
      openKefu: false,
      telescopic: true,

      isClk: false, //上班时间显示与否

      fullHeight: document.documentElement.clientHeight,
      scrollLeft: 0,
    };
  },
  created() { },
  mounted() {
    this.scolltop();
    window.addEventListener("scroll", this.topScroll);
    //this.initDatePicker();
     // 监听页面可见，调用神策登录埋点
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    // 监听页面加载，调用神策登录埋点
    window.addEventListener("load", this.handleVisibilityChange);
  },
  beforeDestroy() {
     window.removeEventListener('load', this.handleVisibilityChange);
     document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  destroyed() {
    // 离开该页面需要移除这个监听的事件，不然会报错
    window.removeEventListener("scroll", this.topScroll);
  },
  methods: {
    async handleVisibilityChange() {
      console.log('页面变得可见22222');
       if (document.visibilityState === 'visible') {
        console.log('页面变得可见22222');
        // 执行你的代码，例如发送页面可见通知等
        if (![null, 'null'].includes(getCookie("JWT-TOKEN"))) {
          console.log('登录');
          let customerInfo = await getAccountInfo(this);
           console.log('登录', customerInfo);
          // sensors.login(customerInfo.CustomerID);
        } else {
          console.log('未登录');
        }
      } 
    },
    isHome() {
      let navPath = false
      if (this.$route.path == "/customerCenter") navPath = true;
      return navPath;
    },
    isAuto(){
      return [
        "/myAccount/billList",
        "/myAccount/checkInvoice",
      ].some((item) => this.$route.fullPath.indexOf(item) !== -1);
     
    },
    //回到顶部
    topScroll() {
      //var topDistance = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop//获取鼠标在本窗口现有状态下移动的高度
      $(window).scroll(function () {
        var topDistance = $(window).scrollTop(); //获取鼠标在本窗口现有状态下移动的高度
        if (topDistance > 100) {
          //如果移动高度大于100px,顶部图标单单显示出，如果移动高度小于等于100，顶部图标不显示
          $(".return_top").fadeIn(800);
        } else {
          $(".return_top").fadeOut(800);
        }
      });
      this.scrollLeft =
        document.body.scrollLeft || document.documentElement.scrollLeft;
    },
    goTop() {
      $("html,body").animate({ scrollTop: 0 }, 800);
    },

    //点击上班时间，展示时间出来
    clkWorkday() {
      this.isClk = !this.isClk;
    },

    clickKefu() {
      this.openKefu = !this.openKefu;
      this.telescopic = !this.telescopic;

      //this.$refs.aa.style.transform='translate(100px,0px)';
    },
    scolltop() {
      let navheight = this.fullHeight;
      this.$refs.left.style.height = navheight + "px";
    },
    goClick() {
      //this.$refs.rightTop.closePopup();
    },

    /*监听滚动条*/
    handleScroll: function () {
      let innerh = window.innerHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let aaa = innerh + scrollTop;
      this.alertStyle.height = aaa + "px";
    }
  }
};
</script>

<style type="text/css" rel="stylesheet" scoped="scoped">
.top {
  width: 100%;
  height: 60px;
  line-height: 60px;
  min-width: 1440px;
  font-size: 20px;
  color: #fff;
  z-index: 2000;
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  width: -webkit-fill-available;
}

.guanyuIEB {
  border-top: 2px solid #ececec;
}
.guanyuIEB p {
  margin: 20px auto 0;
  width: 100px;
  height: 25px;
  line-height: 25px;
  background: #ff8508;
  color: #fff;
  text-align: center;
  border-radius: 4px;
}
.guanyuIEC {
  position: relative;
  height: 300px;
}
.guanyuIEC img {
  width: 100px;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.guanyuIEC p {
  position: absolute;
  bottom: 40px;
  padding: 0 26px;
  line-height: 20px;
}
.guanyuIEC p span {
  color: #ff8508;
}
.guanyuIEtop {
  height: 30px;
  line-height: 30px;
  background: #f0f0f0;
  padding: 0 10px;
}
.guanyuIEbox {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 540px;
  height: 400px;
  background: #fff;
}
.inquiryTopL {
  font-size: 18px;
  margin-left: 88px;
}
.inquiryTopR {
  margin-right: 30px;
  cursor: pointer;
}
.inquiryTop {
  line-height: 45px;
  height: 45px;
  background: #0c5ee4;
  color: #fff;
}
.inquirybox {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 493px;
  height: 336px;
  background: #fff;
}

.kefuBb {
  font-size: 12px;
  color: #333;
}
.kefutel {
  display: inline-block;
  line-height: 30px;
  padding-left: 15px;
  margin: 5px;
  border-bottom: 1px solid #e6e5e4;

  background: url("../../../static/img/float_s.gif") no-repeat -5px -270px;
}
.kefuB {
  background: #ffffff;
  margin-top: 5px;
  border-radius: 6px;
}
.kefuC {
  text-align: center;
  background: #fff;
  margin-top: 5px;
  border-radius: 6px;
}
.luyan {
  display: inline-block;
  width: 90px;
  height: 30px;
  background: url("../../../static/img/massage_ico.jpg") no-repeat center;
  margin-top: 3px;
}
.kefuT {
  background: #ffffff;
  border-radius: 6px;
  padding-bottom: 5px;
}
.kefutitle {
  line-height: 30px;
  color: #00a0e9;
  font-size: 15px;
  text-align: center;
  border-bottom: 1px solid #e6e5e4;
  margin: 0 5px;
}
.workday {
  line-height: 30px;
  color: #00a0e9;
  font-size: 15px;
  text-align: center;
  margin: 0 5px;
  cursor: pointer;
}
.workday em {
  font-weight: bold;
  font-size: 16px;
}
.workdayText {
  margin: 5px 0 0 5px;
  padding-bottom: 5px;
}
.workdayText p {
  font-size: 10px;
  color: #666;
  line-height: 20px;
  text-align: left;
}
.margBtm10 {
  margin: 5px 0;
}
.displayfixdeC {
  display: flex;
  justify-content: center;
  line-height: 25px;
}

.displayfixdeC span {
  color: #ff8508;
  font-size: 12px;
  line-height: 16px;
  padding-left: 3px;
}
.kefu {
  position: fixed;
  right: 0;
  display: flex;
  justify-content: inherit;
  z-index: 999;
}

.kerful {
  margin-top: 36px;
}
.kefur {
  border-bottom-left-radius: 6px;
  border-top-left-radius: 6px;
  border: 5px solid #00a0e9;
  width: 100px;
  background: #00a0e9;

  transition: width 2s;
}
.kefuClose {
  display: block;
  width: 28px;
  height: 118px;
  background: url("../../../static/img/float_s.gif") no-repeat 0 -397px;
}
.kefuOpen {
  display: block;
  width: 28px;
  height: 118px;
  background: url("../../../static/img/float_s.gif") no-repeat -30px -397px;
}

.left {
  width: 200px;
  position: fixed;
  z-index: 999;
  /* height: 100%; */
}
.right {
  flex: 1;
  min-width: 600px;
  margin-left: 200px;
}
.index {
  display: flex;
  justify-content: inherit;
}
.boxHeight {
  margin-top: 64px;
}
</style>



// WEBPACK FOOTER //
// src/components/backstageManagement/index.vue